<template>
    <vs-dialog v-model="active" prevent-close @close="getBorrar">
    <template #header>
        <h4 class="not-margin">
        <b>Agregar</b>
        </h4>
    </template>


    <div class="con-form">
        <vs-row>
            <vs-col>
                <label for="materia"  class="labelInput">Materia</label>
                <vs-input class="pt-0" id="materia" placeholder="Escriba la materia" v-model="materia">
                    <template #message-danger v-if="errorFields.includes('materia')">
                        Requerido
                    </template>
                </vs-input>
            </vs-col>
            <vs-col class="mt-1">
                <label for="seleccion"  class="labelInput">Promediar</label>
                <vs-select class="pt-0" placeholder="Seleccionar" v-model="promediar" filter>
                    <template #message-danger v-if="errorFields.includes('promediar')">
                        Requerido
                    </template>
                    <vs-option v-for="option in configuracion" :key="option.id"  :label="option.nombre" :value="option.opcion">
                        {{option.nombre}}
                    </vs-option>
                </vs-select>
            </vs-col>
            <vs-col class="mt-1">
                <label for="seleccion"  class="labelInput">Acción</label>
                <vs-select class="pt-0" placeholder="Seleccionar" v-model="accion">
                    <template #message-danger v-if="errorFields.includes('accion')">
                        Requerido
                    </template>
                    <vs-option label="Promedia" value="promedia">
                        Promedia
                    </vs-option>
                    <vs-option label="Suma" value="suma">
                        Suma
                    </vs-option>
                </vs-select>
            </vs-col>
        </vs-row>
    </div>

    <template #footer>
        <div class="footer-dialog">
            <vs-row>
                <vs-col sm="6" lg="6">
                <vs-button
                    danger
                    flat
                    @click="getBorrar()"
                >
                    Cancelar
                </vs-button>
                </vs-col>
                <vs-col sm="6" lg="6">
                <vs-button
                    success
                    @click="getGuardarActualizar()"
                    class="ml-auto"
                >
                    Aceptar
                </vs-button>
                </vs-col>
            </vs-row>
        </div>
    </template>
    </vs-dialog>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
export default {
    props:[
        'value',
        'institucion',
        'cicloEscolar'
    ],
    data(){
        return{
            active: false,
            materia:'',
            promediar:'',
            accion:'',
            configuracion: [
                {
                    "id": "1",
                    "nombre": "Calificación",
                    "opcion": "calificacion"
                },
                {
                    "id": "2",
                    "nombre": "Faltas",
                    "opcion": "faltas"
                },
                {
                    "id": "3",
                    "nombre": "Retardos",
                    "opcion": "retardos"
                },
                {
                    "id": "4",
                    "nombre": "Conducta",
                    "opcion": "conducta"
                },
                {
                    "id": "5",
                    "nombre": "Tares no hechas",
                    "opcion": "tareas_no_hechas"
                }
            ],
            continuar: false,
            errorFields:[],
        }
    },
    methods: {
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('string', this.materia)) {
                this.errorFields.push('materia')
            }
            if (!this.checkByType ('string', this.promediar)) {
                this.errorFields.push('promediar')
            }
            if (!this.checkByType ('string', this.accion)) {
                this.errorFields.push('accion')
            }
            if (!this.errorFields.length){
                return this.continuar = true
            } else {
                return this.continuar = false
            }
        },
        async getGuardarActualizar(){
            this.sanityForm()
            if(this.continuar === true){
                const loading = this.$vs.loading()
                try{
                    const formData = new FormData()
                    formData.append('materia_promediable_id', 0)
                    formData.append('ciclo_escolar_id', this.cicloEscolar)
                    formData.append('institucion_id', this.institucion)
                    formData.append('nombre', this.materia)
                    formData.append('promediar', this.promediar)
                    formData.append('accion', this.accion)
                    const { data: response } = await academico.getGuardarActualizar(formData)
                    this.$emit('refreshTable')
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        duration: 5000,
                        color: 'success',
                        title: 'Se ha creado éxitosamente la materia',
                    })
                    this.getBorrar()
                }catch{
                    this.getBorrar()
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        duration: 8000,
                        color: 'danger',
                        title: 'Hubo un error',
                        text: 'Favor de contactar al administrador'
                    })

                }
            }
        },
        getBorrar(){
            this.active =  false
            this.materia = ''
            this.promediar = ''
            this.accion = ''
        }
    },
    watch:{
        
        value (val) {
            this.active = val
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>